//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiCell from "../../components/cell/Index.vue";
import HiButton from "../../components/button/Index.vue";
import HiHeader from "../../components/header/Index.vue";
import InstagramUserItem from "../../components/plan/instagram_user_item/Index.vue";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import { showErrorMsg } from "../../utils/error";

export default {
  name: "MemberDetailPage",
  components: { HiCell, HiHeader, InstagramUserItem, HiButton },
  data() {
    return {
      showMaxSize: 5,
    };
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    /**
     * 获取当前member详情
     */
    detail() {
      const detail = this.user.teamMemberList.find(
        (t) => Number(t.id) === Number(this.$route.params.id)
      );
      return detail;
    },
    /**
     * 计算当前所选中的member
     */
    teamMemberDetail() {
      return this.user.teamMemberList.find(
        (t) => Number(t.id) === Number(this.$route.params.id)
      );
    },
    /**
     * 可以选中的用户数量
     */
    canSelectNum() {
      return this.user.linkedInstagramList
        .filter((l) => !l.isMember && l.status === 1)
        .filter((l) => {
          // 过滤已选中
          return !this.teamMemberDetail.publishers.find(
            (p) => p.publisherId === l.publisherId
          );
        }).length;
    },
  },
  methods: {
    /**
     * 删除member点击事件
     */
    async delMemberClick() {
      try {
        await this.$confirm.show(`${this.$t("memberDetailPage.del")}?`);
        this.$loading.show();
        await this.detail.remove();
        this.$router.go(-1);
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
    /**
     * 添加instagram账号样式
     */
    async addInstagramAccountClick() {
      // 当可选数量为0时，显示确认框，跳转到add instagram 页面
      // if (this.canSelectNum === 0) {
      //   await this.$confirm.show({
      //     text: this.$t('inviteMemberPage.isInsNulText'),
      //     yesText: this.$t('common.add')
      //   })
      //   this.$router.push({name: 'LoginInstagramPage'})
      //   return
      // }
      this.$router.push({
        name: "TeamMemberAddInstagramAccountPage",
        params: { id: this.$route.params.id },
      });
    },
    /**
     * 修改member按钮点击事件
     */
    async changeClick() {
      const _this = this;
      const email = await this.$confirm.show({
        input: "",
        title: this.$t("memberDetailPage.change"),
        placeholder: this.$t("inviteMemberPage.emailTitle"),
        inputValidate({ input }) {
          // 获取用户所有member
          const hasSameEmail = _this.user.teamMemberList.find(
            (m) => m.memberEmail === input
          );
          if (!input) {
            throw new Error(this.$t("validate.empty"));
          }
          // eslint-disable-next-line
          if (
            /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
              input
            ) === false
          ) {
            throw new Error(this.$t("validate.emailFormat"));
          }
          // 验证邮箱是否被重复邀请过
          if (hasSameEmail) {
            throw new Error(this.$t("inviteMemberPage.sameEmailMsg"));
          }
          // 如果当前账号是自己弹出提示
          if (_this.user.email === input) {
            throw new Error(this.$t("inviteMemberPage.isMeEmail"));
          }
          return true;
        },
      });
      try {
        this.$loading.show();
        const id = await this.detail.modifyEmail({ email });
        this.$router.replace({
          name: "MyPlanMemberDetailPage",
          params: { id },
        });
        this.$toast.show({ message: this.$t("common.success") });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
    /**
     * 删除对应instamgram item
     * @param item 选中项
     * @returns {Promise<void>}
     */
    async delClick(item) {
      try {
        await this.$confirm.show(this.$t("common.delTitle"));
        this.$loading.show();
        await item.remove();
        this.$toast.show({ message: this.$t("common.success") });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
    /**
     * 更多按鈕点击事件
     */
    moreClick() {
      this.$router.push({
        name: "TeamMemberInstagramMorePage",
        params: { id: this.$route.params.id },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/team_member/MemberDetail.vue